import { DietaryRequirementType, Speciality } from "@/api/dtos";

export const requiresSpecialitySpecification = ({value}: any) => value.speciality == Speciality.Other;
export const specifyDietaryRequirementCondition = ({value}: any) => value?.dietaryRequirement === DietaryRequirementType.SpecificFoodAllergy;
export const countryIsAustralia = ({value}: any) => value?.country?.toLowerCase() === "australia";